import useWidth from "app/hooks/useWidth";
import { useTheme } from "app/shared";
import arrowDown from "assets/img/icons/arrow-down-white.svg";
import { FC, useState } from "react";
import { getNetworkIcon } from "../ supported-networks-icons/ supported-networks-config";
import styles from "./network-selector.module.scss";

interface NetworkSelectorProps {
  supportedNetworks: { name: string; chainId: number; contract: string }[];
  currentChainId: number;
  onNetworkChange: (chainId: number) => void;
  type: "preorder" | "sale";
}

const NetworkSelector: FC<NetworkSelectorProps> = ({
  supportedNetworks,
  currentChainId,
  onNetworkChange,
  type,
}) => {
  const { isTablet, isMobile } = useWidth();
  const { theme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const currentNetwork = supportedNetworks.find(
    (network) => network.chainId === currentChainId
  );
  const CurrentIcon = currentNetwork
    ? getNetworkIcon(currentNetwork.name)
    : null;

  const handleSelect = (chainId: number) => {
    onNetworkChange(chainId);
    setIsOpen(false);
  };

  if (isTablet || isMobile) {
    return (
      <div className={styles.networkSelector}>
        <div className={styles.tabs}>
          <h3>Selected Networks:</h3>
          {supportedNetworks.map((network) => {
            const Icon = getNetworkIcon(network.name);
            return (
              <button
                key={network.chainId}
                onClick={() => onNetworkChange(network.chainId)}
                className={`${styles.tab} ${
                  network.chainId === currentChainId ? styles.activeTab : ""
                }`}
              >
                {Icon && <Icon />}
                {network.name}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.networkSelector}>
      <label
        htmlFor="custom-network-select"
        className={`${type === "preorder" ? styles.label : styles.saleLabel} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        <span>Select Network:</span>
      </label>
      <div className={styles.customSelectWrapper}>
        {currentNetwork && CurrentIcon && (
          <span className={styles.selectedIcon}>
            <CurrentIcon />
          </span>
        )}
        <div
          id="custom-network-select"
          className={`${styles.select} ${
            theme === "light" ? styles.buySelect : styles.buySelectDark
          } ${isOpen ? styles.selectOpen : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className={styles.selectedValue}>
            {currentNetwork?.name || "Select network"}
          </div>
          <span className={styles.arrowIcon}>
            <img src={arrowDown} alt="" />
          </span>
          {isOpen && (
            <div className={styles.dropdown}>
              {supportedNetworks.map((network) => {
                const Icon = getNetworkIcon(network.name);
                return (
                  <div
                    key={network.chainId}
                    className={`${styles.option} ${
                      network.chainId === currentChainId
                        ? styles.selectedOption
                        : ""
                    }`}
                    onClick={() => handleSelect(network.chainId)}
                  >
                    {Icon && (
                      <span className={styles.optionIcon}>
                        <Icon />
                      </span>
                    )}
                    {network.name}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NetworkSelector;
